import { Slide } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import { ValueInput } from '@utils/formattersV2';
import { texts } from './texts';
import { CampaignOverviewSlideOptions } from '../campaign-overview/campaign-overview';
import { buildCampaignOverviewSlide2 } from '@features/executive-report/slides/campaign-overview-2/campaign-overview-2';
import { buildDriverTextsOptions } from './driver-texts';
import { shapes } from '@features/executive-report/slides/campaign-overview-2/shapes';
import { driverShapes } from './shapes';

const DRIVER_OFFSET = 1.5;

export type CampaignOverviewSlide2Options = {
  brandLogoWithMetadata: ImageWithMetadata | null;
  report: CampaignOverviewSlideOptions['report'];
  iroas: ValueInput;
  objectives: string[];
};

export const campaignOverviewSlide2 = (
  options: CampaignOverviewSlide2Options
): Slide => {
  const driverTextsOptions = buildDriverTextsOptions(options.report).map(
    (driverTextsOptions, index) => ({
      ...driverTextsOptions,
      index,
    })
  );

  const driverValues = driverTextsOptions.map(
    options => options.salesValue ?? 0
  );

  return buildCampaignOverviewSlide2(
    options.brandLogoWithMetadata,
    texts({
      ...options,
      driverTextsOptions,
    }),
    shapes(
      driverValues.flatMap((_, i) => driverShapes(i, DRIVER_OFFSET)),
      options.report.incrementalSalesLift ?? 0
    )
  );
};
